import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import ClientListWithMap from '../ClientListWithMap';

import SubHeader from './SubHeader';
import { api } from '../../../services';
import { withRouter } from 'react-router-dom';

import './Dashboard.css';

@withRouter
@inject('carsStore', 'translationsStore', 'filterStore', 'commonStore', 'noticesStore', 'lockbeatStore', 'mapStore', 'groupsStore', 'authStore')
@observer
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cars: [],
      carsList: [],
      carsCount: [],
      carsFilters: {
        journeyOn: 0,
        journeyOff: 0,
        ignitionOn: 0,
        ignitionOff: 0,
        disconnected: 0,
        withMaintenance: 0,
        withAlarms: 0,
        withDtcs: 0,
        withBatteryDown: 0,
        withLockOn: 0,
        withLockOff: 0,
        withNotices: 0
      },
      filters: {},
      loading: true,
      pageSize: 4,
      page: 1
    };

    // this.setState({ loading: true });
    this.loadData().then(() => {
      this.setState({ loading: false });
    });
  }

  loadData() {
    const { commonStore, groupsStore, authStore } = this.props;
    commonStore.setLoading(true);
    //
    return Promise.all([groupsStore.load(), this.loadList(), ...!authStore.isServiceManager ? [this.loadMap(), this.loadFilters()] : []]).then(() => {
      commonStore.setLoading(false);
    });
  }

  loadDashboard() {
    return api('get dashboard',
      this.state.filters,
      this.state.pageSize,
      this.state.page).then(res => {
      this.setState({ carsList: res.list.rows, carsCount: res.list.count, carsFilters: res.filters, carsMap: res.map.rows });
    });
  }

  loadList() {
    return api('get dashboard cars list',
      this.state.filters,
      this.state.pageSize,
      this.state.page).then(res => {
      this.setState({ carsList: res.rows, carsCount: res.count });
    });
  }

  loadFilters() {
    if (!this.props.authStore.isServiceManager) {
      return api('get dashboard cars filters',
      this.state.filters).then(res => {
        this.setState({ carsFilters: res });
      });
    }
  }

  loadMap() {
    if (!this.props.authStore.isServiceManager) {
      return api('get dashboard cars map',
      this.state.filters).then(res => {
        this.setState({ carsMap: res.rows });
      });
    }
  }

  componentDidMount = () => {
  };

  componentWillUnmount = () => {
    this.props.filterStore.reset();
  };

  isShowDetail() {
    return !!this.props.match.params.carId;
  }

  getClientId() {
    return this.props.match.params.carId;
  }

  onPageListChange = (page, pageSize) => {
    this.setState({ page: page, pageSize: pageSize }, () => {
      this.loadList();
    });
  }

  onGroupChange = (groupId) => {
    let filters = this.state.filters;
    if (groupId > 0) {
      filters.groupId = groupId;
    } else {
      delete filters.groupId;
    }
    this.setState({ filters: filters, page: 1 }, () => {
      this.loadList();
      this.loadFilters();
      this.loadMap();
    });
  }

  onToggleFilter = (name, reload = true) => {
    let filters = this.state.filters;
    if (filters[`${name}`]) {
      delete filters[`${name}`];
    } else {
      filters[`${name}`] = true;
    }
    if (reload) {
      this.setState({ filters: filters, page: 1 }, () => {
        this.loadList();
        this.loadFilters();
        this.loadMap();
      }, 10);
    }
  }

  onRemoveFilter = (name) => {
    let filters = this.state.filters;
    if (filters[`${name}`]) {
      delete filters[`${name}`];
    }
  }

  onResetFilters = () => {
    this.setState({ filters: {}, page: 1 }, () => {
      this.loadList();
      this.loadFilters();
      this.loadMap();
    }, 10);
  }

  onReload = () => {
    this.loadList();
    this.loadFilters();
    this.loadMap();
  }

  onApplyFilter = () => {
    this.setState({ page: 1 }, () => {
      this.loadList();
      this.loadFilters();
      this.loadMap();
    }, 10);
  }

  onFullTextSearch = (fullTextSearch) => {
    let filters = this.state.filters;
    if (fullTextSearch !== '') {
      filters.fullTextSearch = fullTextSearch;
    } else {
      delete filters.fullTextSearch;
    }
    this.onApplyFilter();
  }

  onClearFullTextSearch = () => {
    this.onRemoveFilter("fullTextSearch");
    this.onApplyFilter();
  }

  onSearchOnMap = (lat, lng, distance) => {
    let filters = this.state.filters;
    filters.map = { lat, lng, distance };
    this.setState({ filters: filters, page: 1 }, () => {
      this.loadList();
      this.loadFilters();
      this.loadMap();
    }, 10);
  }

  onCancelSearchOnMap = () => {
    let filters = this.state.filters;
    delete filters.map;
    this.setState({ filters: filters, page: 1 }, () => {
      this.loadList();
      this.loadFilters();
      this.loadMap();
    }, 10);
  }

  render() {
    const { authStore } = this.props;

    let showMap = !authStore.isServiceManager;
    let { groups } = this.props.groupsStore;
    let { carsMap, carsList, carsCount, page, pageSize, filters, carsFilters } = this.state;
    return (
      <div className="Dashboard">
        <SubHeader cars={carsMap} onResetFilters={this.onResetFilters} onReload={this.onReload} onClearFullTextSearch={this.onClearFullTextSearch} onFullTextSearch={this.onFullTextSearch} />
        {this.props.commonStore.loading === false && (
          <ClientListWithMap
            listWidth="440px"
            loading={this.state.loading}
            imeisWithLockbeat={this.props.lockbeatStore.imeisWithLockbeat}
            cars={carsMap || []}
            list={carsList || []}
            carsCount={carsCount || 0}
            carsFilters={carsFilters || {}}
            filters={filters || {}}
            page={page}
            pageSize={pageSize}
            groups={groups || []}
            showDetail={this.isShowDetail()}
            clientId={this.getClientId()}
            onPageListChange={this.onPageListChange}
            onGroupChange={this.onGroupChange}
            onToggleFilter={this.onToggleFilter}
            onRemoveFilter={this.onRemoveFilter}
            onApplyFilter={this.onApplyFilter}
            onSearchOnMap={this.onSearchOnMap}
            onCancelSearchOnMap={this.onCancelSearchOnMap}
            showMap={showMap}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Dashboard/Dashboard.js